import React from 'react';

interface PodcastIconProps {
  className?: string;
}

function PodcastIcon({ className }: PodcastIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <g clipPath="url(#clip0)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m6.922.05-.49.085c-5 .868-7.592 6.932-4.766 11.15.583.872.546.863 1.302.316.647-.467.623-.41.339-.793C1.378 8.21 1.993 4.242 4.56 2.717c1.785-1.06 4.76-1.12 6.547-.132 2.667 1.477 3.295 4.429 1.65 7.757l-.372.752.457.47c.595.61.607.607 1.213-.284 2.477-3.648.74-9.083-3.439-10.756C9.62.125 7.812-.107 6.922.049zm-.23 2.78c-2.859.783-4.302 3.828-3.074 6.487.23.502.59.985.734.988.244.006 1.032-.687.935-.822-2.396-3.336 1.598-7.248 4.735-4.637 1.217 1.014 1.438 2.551.604 4.217-.316.633-.334.547.19.925.55.397.587.397.878-.01 1.592-2.221.729-5.572-1.75-6.798-.933-.461-2.305-.609-3.252-.35m.596 2.366c-1.243.36-1.646 2.074-.703 2.992 1.14 1.11 3.04.318 3.039-1.267 0-1.232-1.139-2.072-2.336-1.725m-.165 3.883c-.52.131-.774.331-.963.758-.125.284-.125.377.014 1.966.031.363.095 1.18.14 1.813C6.453 15.54 6.744 16 7.827 16c1.1 0 1.378-.447 1.54-2.472.049-.617.113-1.393.143-1.725.16-1.794.144-1.956-.239-2.357-.308-.322-1.512-.528-2.148-.367"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default PodcastIcon;
